import { ChatReceptionStatus, ChatArchiveStatus, ChatAssignTypes } from '@/interfaces/chat';

export const BASE_URL = import.meta.env.DEV ? '' : import.meta.env.BASE_URL;

export const STREAMS_CONTAINER_ID = 'chat-streams-container';

export const EMPTY_AGENT_ID = 0;

export const AI_NAME = '小鼓 AI';

export const WORKFLOW_NAME = '工作流';

export const BUILDER_AI_NAME = '小来';

export const PREVIEW_AI_NAME = '小鼓';

export const DEFAULT_AGENT_NAME = '来鼓客服';

export const CHAT_ASSIGN_LABELS: Record<ChatAssignTypes, string> = {
  [ChatAssignTypes.MY]: '我的',
  [ChatAssignTypes.COLL]: '同事',
  [ChatAssignTypes.UNKNOWN]: '未分配',
};

export const CHAT_RECEPTION_STATUS_LABELS: Record<ChatReceptionStatus, string> = {
  ai_agent: 'AI 托管',
  workflow: '工作流接待',
  manual: '人工接待',
};

export const SOCIAL_CARD_TITLE: Record<number, string> = {
  1: '微信',
  2: '钉钉',
  3: '电话',
  4: '企业微信',
};

export const ARCHIVE_CATEGORY_LABELS: Record<ChatArchiveStatus, string> = {
  true: '已归档',
  false: '未归档',
};
